import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { ValidatorForm } from 'react-material-ui-form-validator';
import VisitaFiliadoRegisterDetalhadoToolbar from './components/VisitaFiliadoRegisterDetalhadoToolbar';
import Paper from '@material-ui/core/Paper';
import VisitaFiliadoRegisterDetalhadoPasso1 from './components/VisitaFiliadoRegisterDetalhadoPasso1';
import VisitaFiliadoRegisterDetalhadoPasso2 from './components/VisitaFiliadoRegisterDetalhadoPasso2';
import VisitaFiliadoRegisterDetalhadoPasso3 from './components/VisitaFiliadoRegisterDetalhadoPasso3';
import ProgressFullScreen from '../../components/Compartilhados/ProgressFullScreen';
import SnackbarCustom from '../../components/Compartilhados/Snackbar';
import { ServiceValues } from '../../values/ServiceValues';
import { ServiceAxios } from '../../services/ServiceEW';
import {
  GridList,
  IconButton,
  TextField,
  useMediaQuery,
  useTheme,
  Card,
  CardContent,
  Avatar
} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { Values } from '../../values/Values';
import { getAllPacotes } from '../../services/PacoteService';
import { getAllInsumos } from '../../services/InsumoService';
import { getAllArmas } from '../../services/ArmaService';
import { getAllModalidades } from '../../services/ModalidadesService';
import { getEmpresaPrincipal } from '../../services/EmpresaService';
import moment from 'moment';
import {
  deleteVisitaFiliado,
  getVisitaFiliado,
  postVisitaFiliado,
  putVisitaFiliado
} from '../../services/VisitaFiliadoService';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Alert from '@material-ui/lab/Alert/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle/AlertTitle';
import InputAdornment from '@material-ui/core/InputAdornment';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import FingerprintIcon from '@material-ui/icons/Fingerprint';

const useStyles = makeStyles(theme => ({
  root: {},
  button: {
    marginRight: theme.spacing(1)
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  toolbar: {
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3)
  }
}));

export default function VisitaFiliadoRegisterDetalhado({ history }) {
  const timeout = ServiceValues.timeout;
  const baseUrl = ServiceValues.base_url_local;
  const api = ServiceAxios(baseUrl, timeout);
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const [skipped, setSkipped] = useState(new Set());
  const steps = getSteps();
  const [visitaFiliado, setVisitaFiliado] = useState(
    history.location.state.visitaFiliado
  );
  const [edicao, setEdicao] = useState(history.location.state.edicao);
  const [loading, setLoading] = React.useState(false);
  const [showMessageSnack, setShowMessageSnack] = useState(false);
  const [messageSnack, setMessageSnack] = useState('');
  const [typeSnack, setTypeSnack] = useState('success');
  const [senha, setSenha] = useState('');
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [armas, setArmas] = useState({
    result: []
  });
  const [insumos, setInsumos] = useState({
    result: []
  });
  const [pacotes, setPacotes] = useState({
    result: []
  });
  const [modalidades, setModalidades] = useState({
    result: []
  });
  const [empresa, setEmpresa] = useState({
    result: []
  });
  const [
    showDialogConfirmacaoDeleteVisitaFiliado,
    setShowDialogConfirmacaoDeleteVisitaFiliado
  ] = useState(false);
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true
  });
  const [refreshStatePai, setRefreshStatePai] = useState(new Date());

  useEffect(() => {
    getModalidades();
    getArmas();
    getInsumos();
    getPacotes();
    recarregarVisita();
    getEmpresa();
  }, []);

  async function recarregarVisita() {
    try {
      if (visitaFiliado.idVisitaFiliado) {
        setLoading(true);
        const dados = await api.get(
          `visita-filiados/${visitaFiliado.idVisitaFiliado}`
        );
        setLoading(false);
        if (dados.data.isSuccess) {
          if (dados.data.result && dados.data.result.length > 0) {
            setVisitaFiliado(dados.data.result[0]);
            setLoading(false);
          } else {
            setLoading(false);
            setTypeSnack('error');
            setMessageSnack(Values.MessageValues.erro_catch);
            setShowMessageSnack(true);
          }
        } else {
          setLoading(false);
          setTypeSnack('error');
          setMessageSnack(Values.MessageValues.erro_catch);
          setShowMessageSnack(true);
        }
      }
    } catch (e) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack(Values.MessageValues.erro_catch);
      setShowMessageSnack(true);
    }
  }

  async function getPacotes() {
    try {
      setLoading(true);
      let pacotes1 = await getAllPacotes(100, 1);
      if (pacotes1.isSuccess) {
        setLoading(false);
        setPacotes(pacotes1);
      } else {
        setLoading(false);
        setTypeSnack('warning');
        setMessageSnack(pacotes1.message);
        setShowMessageSnack(true);
      }
    } catch (e) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack(Values.MessageValues.erro_catch);
      setShowMessageSnack(true);
    }
  }

  async function getInsumos() {
    try {
      setLoading(true);
      let insumos1 = await getAllInsumos(100, 1);
      if (insumos1.isSuccess) {
        setLoading(false);
        setInsumos(insumos1);
      } else {
        setLoading(false);
        setTypeSnack('warning');
        setMessageSnack(insumos1.message);
        setShowMessageSnack(true);
      }
    } catch (e) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack(Values.MessageValues.erro_catch);
      setShowMessageSnack(true);
    }
  }

  async function getArmas() {
    try {
      setLoading(true);
      let armas1 = await getAllArmas(100, 1);
      if (armas1.isSuccess) {
        setLoading(false);
        setArmas(armas1);
      } else {
        setLoading(false);
        setTypeSnack('warning');
        setMessageSnack(armas1.message);
        setShowMessageSnack(true);
      }
    } catch (e) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack(Values.MessageValues.erro_catch);
      setShowMessageSnack(true);
    }
  }

  async function getModalidades() {
    try {
      setLoading(true);
      let modalidades1 = await getAllModalidades(100, 1);
      if (modalidades1.isSuccess) {
        setLoading(false);
        setModalidades(modalidades1);
      } else {
        setLoading(false);
        setTypeSnack('warning');
        setMessageSnack(modalidades1.message);
        setShowMessageSnack(true);
      }
    } catch (e) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack(Values.MessageValues.erro_catch);
      setShowMessageSnack(true);
    }
  }

  async function getEmpresa() {
    try {
      setLoading(true);
      let empresa = await getEmpresaPrincipal();
      if (empresa.isSuccess) {
        setLoading(false);
        setEmpresa(empresa);
      } else {
        setLoading(false);
        setTypeSnack('warning');
        setMessageSnack(empresa.message);
        setShowMessageSnack(true);
      }
    } catch (e) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack(Values.MessageValues.erro_catch);
      setShowMessageSnack(true);
    }
  }

  function getSteps() {
    return [
      'Informações básicas',
      'Registro de disparos e consumo',
      'Finalização e pagamento'
    ];
  }

  function getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <VisitaFiliadoRegisterDetalhadoPasso1
            visitaFiliado={visitaFiliado}
            setVisitaFiliado={setVisitaFiliado}
            setShowMessageSnack={setShowMessageSnack}
            setMessageSnack={setMessageSnack}
            setTypeSnack={setTypeSnack}
            setLoading={setLoading}
            setRefreshStatePai={setRefreshStatePai}
          />
        );
      case 1:
        return (
          <VisitaFiliadoRegisterDetalhadoPasso2
            setShowMessageSnack={setShowMessageSnack}
            setMessageSnack={setMessageSnack}
            setTypeSnack={setTypeSnack}
            setLoading={setLoading}
            visitaFiliado={visitaFiliado}
            setVisitaFiliado={setVisitaFiliado}
            modalidades={modalidades}
            armas={armas}
            insumos={insumos}
            pacotes={pacotes}
          />
        );
      case 2:
        return (
          <VisitaFiliadoRegisterDetalhadoPasso3
            setShowMessageSnack={setShowMessageSnack}
            setMessageSnack={setMessageSnack}
            setTypeSnack={setTypeSnack}
            setLoading={setLoading}
            visitaFiliado={visitaFiliado}
            setVisitaFiliado={setVisitaFiliado}
            empresa={empresa}
            history={history}
          />
        );
    }
  }

  const isStepOptional = step => {
    return step === 1;
  };

  const isStepSkipped = step => {
    return skipped.has(step);
  };

  const handleNext = async () => {
    try {
      if (activeStep == 1) {
        if (visitaFiliado.visitaFiliadoMods.length <= 0) {
          setTypeSnack('warning');
          setMessageSnack('Informe ao menos uma modalidade');
          setShowMessageSnack(true);
          return;
        }
        for (let i = 0; i < visitaFiliado.visitaFiliadoMods.length; i++) {
          for (
            let j = 0;
            j < visitaFiliado.visitaFiliadoMods[i].visitaFiliadoDisps.length;
            j++
          ) {
            if (
              visitaFiliado.visitaFiliadoMods[i].visitaFiliadoDisps[j]
                .utilizaPacote &&
              !visitaFiliado.visitaFiliadoMods[i].visitaFiliadoDisps[j].idPacote
            ) {
              setTypeSnack('error');
              setMessageSnack(
                'Selecione um pacote para modalidade ' +
                  visitaFiliado.visitaFiliadoMods[i].modalidade.descricao
              );
              setShowMessageSnack(true);
              setLoading(false);
              return;
            }
            if (
              !visitaFiliado.visitaFiliadoMods[i].visitaFiliadoDisps[j]
                .armaPropria &&
              !visitaFiliado.visitaFiliadoMods[i].visitaFiliadoDisps[j].idArma
            ) {
              setTypeSnack('error');
              setMessageSnack(
                'Selecione uma arma para modalidade ' +
                  visitaFiliado.visitaFiliadoMods[i].modalidade.descricao
              );
              setShowMessageSnack(true);
              setLoading(false);
              return;
            }
            if (
              !visitaFiliado.visitaFiliadoMods[i].visitaFiliadoDisps[j]
                .insumoProprio &&
              !visitaFiliado.visitaFiliadoMods[i].visitaFiliadoDisps[j].idInsumo
            ) {
              setTypeSnack('error');
              setMessageSnack(
                'Selecione um insumo para modalidade ' +
                  visitaFiliado.visitaFiliadoMods[i].modalidade.descricao
              );
              setShowMessageSnack(true);
              setLoading(false);
              return;
            }
          }
        }
      }
      setLoading(true);
      if (!visitaFiliado.idFiliado || !visitaFiliado.filiado) {
        setTypeSnack('error');
        setMessageSnack(
          'Necessário informar o filiado associado a essa visita.'
        );
        setShowMessageSnack(true);
        setLoading(false);
        return;
      }
      if (!visitaFiliado.dataEntrada) {
        setTypeSnack('error');
        setMessageSnack('Necessário informar a data de entrada do filiado.');
        setShowMessageSnack(true);
        setLoading(false);
        return;
      }

      let result;
      if (!visitaFiliado.idVisitaFiliado) {
        result = await postVisitaFiliado(visitaFiliado);
        visitaFiliado.idVisitaFiliado = result.result.idVisitaFiliado;
        setVisitaFiliado(result.result);
      } else {
        result = await putVisitaFiliado(visitaFiliado);
      }
      if (result.isSuccess) {
        setLoading(true);
        const dados = await getVisitaFiliado(visitaFiliado);
        setLoading(false);
        if (dados.isSuccess) {
          if (dados.result.length > 0) {
            setVisitaFiliado(dados.result[0]);
            let newSkipped = skipped;
            if (isStepSkipped(activeStep)) {
              newSkipped = new Set(newSkipped.values());
              newSkipped.delete(activeStep);
            }
            setActiveStep(prevActiveStep => prevActiveStep + 1);
            setSkipped(newSkipped);
            setLoading(false);
          } else {
            setLoading(false);
            setTypeSnack('error');
            setMessageSnack(
              'Ocorreu um erro ao obter dados da visita do filiado.'
            );
            setShowMessageSnack(true);
          }
        } else {
          setLoading(false);
          setTypeSnack('error');
          setMessageSnack(dados.message);
          setShowMessageSnack(true);
        }
      } else {
        setTypeSnack('error');
        setMessageSnack(result.message);
        setShowMessageSnack(true);
        setLoading(false);
      }
    } catch (e) {
      setTypeSnack('error');
      setMessageSnack(
        'Ocorreu um erro no processamento da requisição. Contate o suporte.'
      );
      setShowMessageSnack(true);
      setLoading(false);
    }
  };

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  };

  async function saveVisitaAndExit() {
    try {
      setLoading(true);
      if (!visitaFiliado.idFiliado || !visitaFiliado.filiado) {
        setTypeSnack('error');
        setMessageSnack(
          'Necessário informar o filiado associado a essa visita.'
        );
        setShowMessageSnack(true);
        setLoading(false);
        return;
      }
      if (!visitaFiliado.dataEntrada) {
        setTypeSnack('error');
        setMessageSnack('Necessário informar a data de entrada do filiado.');
        setShowMessageSnack(true);
        setLoading(false);
        return;
      }
      let result;
      if (!visitaFiliado.idVisitaFiliado) {
        result = await postVisitaFiliado(visitaFiliado);
      } else {
        result = await putVisitaFiliado(visitaFiliado);
      }

      if (result.isSuccess) {
        setLoading(false);
        history.push('/visita-filiado-list');
      } else {
        setLoading(false);
        setTypeSnack('error');
        setMessageSnack(result.message);
        setShowMessageSnack(true);
      }
    } catch (e) {
      setTypeSnack('error');
      setMessageSnack(
        'Ocorreu um erro no processamento da requisição. Contate o suporte..' +
          e.toString()
      );
      setShowMessageSnack(true);
      setLoading(false);
    }
  }

  function showConfirmationDeleteVisitaFiliado() {
    setShowDialogConfirmacaoDeleteVisitaFiliado(true);
  }

  async function deleteVisita(event) {
    try {
      setShowDialogConfirmacaoDeleteVisitaFiliado(false);
      setLoading(true);
      const auth = JSON.parse(localStorage.getItem('auth'));
      const deleteVisita = await deleteVisitaFiliado(
        visitaFiliado,
        senha,
        auth.result.idUsuario
      );
      setSenha('');
      setLoading(false);
      if (deleteVisita.isSuccess) {
        setTypeSnack('success');
        setMessageSnack(deleteVisita.message);
        setShowMessageSnack(true);
        history.push('/visita-filiado-list');
      } else {
        setTypeSnack('error');
        setMessageSnack(deleteVisita.message);
        setShowMessageSnack(true);
      }
    } catch (e) {
      setTypeSnack('error');
      setMessageSnack(Values.MessageValues.erro_catch);
      setShowMessageSnack(true);
    }
  }

  function onCancelDeleteVisitaFiliado() {
    setShowDialogConfirmacaoDeleteVisitaFiliado(false);
  }

  return (
    <div
      style={{
        margin: theme.spacing(2)
      }}>
      <Grid item md={12} xs={12}>
        <ValidatorForm autoComplete="off" onSubmit={saveVisitaAndExit}>
          <Grid container spacing={2}>
            <ProgressFullScreen open={loading} setOpen={setLoading} />
            <SnackbarCustom
              verticalOrientation="bottom"
              horizontalOrientation="center"
              open={showMessageSnack}
              setOpen={setShowMessageSnack}
              message={messageSnack}
              duration={2000}
              type={typeSnack}
            />
            <Dialog
              open={showDialogConfirmacaoDeleteVisitaFiliado}
              aria-labelledby="form-dialog-title">
              <DialogTitle id="form-dialog-title">
                Tem certeza que deseja remover essa visita?
              </DialogTitle>
              <DialogContent>
                <Alert severity="warning" variant="outlined">
                  <AlertTitle>Atenção</AlertTitle>A remoção de uma visita
                  implica em uma série de responsabilidades para o usuário e
                  para o filiado. Para garantir a integridade do sistema e do
                  usuário, por favor digite sua senha de acesso ao sistema para
                  confirmar essa ação
                </Alert>
                <Typography gutterBottom style={{ marginTop: '30px' }}>
                  {visitaFiliado.filiado &&
                    'Nome do visitante: ' + visitaFiliado.filiado.nome}
                </Typography>
                <Typography gutterBottom>
                  {visitaFiliado.filiado && 'CPF: ' + visitaFiliado.filiado.cpf}
                </Typography>
                <Typography gutterBottom>
                  {'Data entrada: ' +
                    moment(visitaFiliado.dataEntrada).format(
                      'DD/MM/YYYY HH:mm'
                    )}
                </Typography>
                <Typography gutterBottom style={{ marginBottom: '30px' }}>
                  {(visitaFiliado.dataSaida &&
                    'Data saída: ' +
                      moment(visitaFiliado.dataSaida).format(
                        'DD/MM/YYYY HH:mm'
                      )) ||
                    'Data saída: Não informado'}
                </Typography>
                <TextField
                  id="outlined-adornment-password"
                  variant="outlined"
                  margin="dense"
                  fullWidth
                  value={senha}
                  type={mostrarSenha ? 'text' : 'password'}
                  label="Informe a senha"
                  onChange={e => setSenha(e.target.value)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          edge="end"
                          aria-label="toggle password visibility"
                          onClick={e => setMostrarSenha(!mostrarSenha)}>
                          {mostrarSenha ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  helperText="Insira sua senha para confirmação de exclusão dessa visita."
                  validators={['required']}
                  errorMessages={['Senha']}
                />
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={e => onCancelDeleteVisitaFiliado()}
                  color="primary">
                  Cancel
                </Button>
                <Button onClick={e => deleteVisita(e)} color="primary">
                  Confirmar
                </Button>
              </DialogActions>
            </Dialog>
            <Grid item md={12} xs={12}>
              <Card>
                <CardContent>
                  <Grid container>
                    <Grid item>
                      <Avatar
                        style={{
                          backgroundColor: visitaFiliado.startedFingerprint
                            ? '#22bb33'
                            : '#bb2124'
                        }}>
                        {<FingerprintIcon />}
                      </Avatar>
                    </Grid>
                    <Grid
                      item
                      style={{
                        marginLeft: 16,
                        textAlign: 'center',
                        justifySelf: 'center',
                        alignSelf: 'center'
                      }}>
                      <Typography variant="h3">
                        {visitaFiliado.startedFingerprint
                          ? `Digital capturada`
                          : 'Digital não capturada'}
                      </Typography>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            <Grid item md={12} xs={12}>
              <VisitaFiliadoRegisterDetalhadoToolbar
                className={classes.toolbar}
                activeStep={activeStep}
                steps={steps}
                stepNext={handleNext}
                stepBack={handleBack}
                saveVisita={saveVisitaAndExit}
                history={history}
                visitaFiliado={visitaFiliado}
                deleteVisita={showConfirmationDeleteVisitaFiliado}
              />
            </Grid>
            <Grid item md={12} xs={12}>
              <Paper>
                <Stepper
                  activeStep={activeStep}
                  orientation={isDesktop ? 'horizontal' : 'vertical'}>
                  {steps.map((label, index) => {
                    const stepProps = {};
                    const labelProps = {};
                    if (isStepOptional(index)) {
                      labelProps.optional = (
                        <Typography variant="caption">Optional</Typography>
                      );
                    }
                    if (isStepSkipped(index)) {
                      stepProps.completed = false;
                    }
                    return (
                      <Step key={label} {...stepProps}>
                        <StepLabel {...labelProps}>{label}</StepLabel>
                      </Step>
                    );
                  })}
                </Stepper>
                {getStepContent(activeStep)}
              </Paper>
            </Grid>
          </Grid>
        </ValidatorForm>
      </Grid>
    </div>
  );
}
